import React from "react";
import { getFormattedDate, maskString } from "../../../helpers/serviceHelpers";
// import Chip from "../../../components/chip";
import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";

const SingleRow = ({
  title,
  value,
  isChip,
}: {
  title: string;
  value: string;
  isChip?: boolean;
}) => {
  return (
    <TableRow>
      <TableCell>
        <Typography color="#676767" variant="body2">
          {title}
        </Typography>
      </TableCell>
      <TableCell align="right">
        {isChip ? (
          <Typography variant="subtitle2" color="primary">
            {maskString(value)}
          </Typography>
        ) : (
          <Typography variant="body2">{value}</Typography>
        )}
      </TableCell>
    </TableRow>
  );
};

const StatusDetails: React.FC<{
  status: string;
  complaintNo: string;
  requestType: string;
  reportedOn: string;
  serialNo: string;
}> = ({ complaintNo, requestType, reportedOn, serialNo }) => {
  return (
    <Stack className="bg-white rounded-xl flex flex-col gap-3">
      <TableContainer variant="outlined" component={Paper}>
        <Table aria-label="simple table">
          <TableBody>
            <SingleRow title="Serial No." value={serialNo} isChip={true} />
            <SingleRow title="Ticket number" value={complaintNo} />
            <SingleRow title="Request type" value={requestType} />
            <SingleRow
              title="Registered on"
              value={getFormattedDate(reportedOn)}
            />
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default StatusDetails;
